<script setup>
import { useForm } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import HostAuthLayout from '@/Layouts/HostAuthLayout.vue'

defineOptions({ layout: HostAuthLayout })

const { t } = useI18n()
const form = useForm({ identifier: '' })
function submit() { form.post('/password/reset', { preserveScroll: true }) }
</script>

<template>
  <h1 class="reset-title">
    {{ t('host_portal.password_reset.title') }}
  </h1>
  <p class="reset-sub">
    {{ t('host_portal.password_reset.sub') }}
  </p>
  <form
    class="reset-form"
    @submit.prevent="submit"
  >
    <label class="reset-field">
      <span class="reset-label">{{ t('host_portal.otp.request.label') }}</span>
      <input
        v-model="form.identifier"
        type="text"
        required
        autocomplete="off"
        class="reset-input"
      >
    </label>
    <button
      type="submit"
      :disabled="form.processing"
      class="reset-submit"
    >
      {{ form.processing ? t('host_portal.otp.verify.loading') : t('host_portal.password_reset.cta') }}
    </button>
    <a
      href="/login"
      class="reset-link"
    >{{ t('host_portal.password_reset.back') }}</a>
  </form>
</template>

<style scoped>
.reset-title { font-size: 1.25rem; font-weight: 700; color: var(--ink); margin: 0 0 0.5rem; }
.reset-sub   { color: var(--inkSoft); margin: 0 0 1rem; font-size: 0.9375rem; }
.reset-form  { display: grid; gap: 0.875rem; }
.reset-field { display: grid; gap: 0.3rem; }
.reset-label { font-size: 0.8125rem; color: var(--inkSoft); }
.reset-input {
  width: 100%; padding: 0.55rem 0.75rem; background: var(--surface);
  border: 1px solid var(--line); border-radius: var(--radius-input, 8px);
  color: var(--ink); font-size: 0.9375rem;
}
.reset-input:focus { outline: 2px solid var(--accent); outline-offset: 1px; }
.reset-submit {
  padding: 0.65rem 1rem; border: 0; border-radius: var(--radius-button, 8px);
  background: var(--accent); color: var(--accentInk); font-weight: 600; cursor: pointer;
}
.reset-submit:disabled { opacity: 0.6; cursor: progress; }
.reset-link { color: var(--accent); text-decoration: none; font-size: 0.875rem; text-align: center; }
</style>
